<template>
  <div class="step2">
    <div class="step2_body">
      <div class="step2_head">
        <div :class="ct.status == 3 ? 'blue_heng' : 'heng'"
          ><div>{{ ct.status == 3 ? '金融机构正在审核中' : '金融机构审核结果(不通过)' }}</div></div
        >
      </div>
      <div class="step2_tail">
        <img
          :src="
            ct.status == 3
              ? require('../../../../assets/images/viewing.png')
              : require('../../../../assets/images/notpass.png')
          "
          alt=""
          class="pr-10"
        />
        <div class="pr-3 text-base">{{
          ct.status == 3 ? '金融机构正在审核中' : '金融机构审核不通过，请联系客服处理。 '
        }}</div>
        <a-button type="primary" @click="handleSubmit()">上一步</a-button>
      </div>
    </div></div
  >
</template>
<script>
  export default {
    components: {},
    props: {
      ct: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        setting: {},
        banklist: [],
        company: {},
      };
    },
    async mounted() {},
    computed: {},
    watch: {
      ct(a) {
        console.log(a);
      },
    },
    methods: {
      handleSubmit(e) {
        console.log(1332);
        this.$emit('pre');
      },
    },
  };
</script>
<style lang="less" scoped>
  .step2 {
    display: block;
    width: 750px;
    margin: 0 auto;
  }
  .step2_body {
    margin-bottom: 20px;
    background-color: #fff;
    border: 1px solid transparent;
    border-radius: 4px;
  }
  .step2_head {
    color: #4e5969;
    font-weight: bold;
    background-color: #f6f6f8;
    border-color: #f6f6f8;
    padding: 11px 15px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    border-bottom: 1px solid transparent;
  }
  .heng {
    padding-left: 10px;
    position: relative;
    color: #4e5969;
    font-weight: bold;
    font-size: 16px;
  }
  .heng ::before {
    content: '';
    display: inline-block;
    position: absolute;
    width: 4px;
    left: -4px;
    height: 100%;
    background-color: #f6384c;
  }
  .blue_heng {
    padding-left: 10px;
    position: relative;
    color: #4e5969;
    font-weight: bold;
    font-size: 16px;
  }
  .blue_heng ::before {
    content: '';
    display: inline-block;
    position: absolute;
    width: 4px;
    left: -4px;
    height: 100%;
    background-color: #388af6;
  }
  .step2_tail {
    display: flex;
    align-items: center;
    width: 400px;
    height: 60px;
    margin: 20px auto;
    background-color: #ffffff;
  }
</style>
